import { EResidenciesStatusUI } from 'data/types/Animal.types';
import { EGender } from 'data/types/GeneralTypes';
import { ETenantDetailsStatusUI } from 'data/types/Tenant.types';

// A residency is still live in these statuses: the tenant is either going through the application
// flow or currently living in the unit. Rejected / retracted / moved-out residencies are closed.
export const activeTenantResidencyStatuses: ETenantDetailsStatusUI[] = [
  ETenantDetailsStatusUI.PENDING,
  ETenantDetailsStatusUI.APPROVED,
  ETenantDetailsStatusUI.MOVED_IN,
  ETenantDetailsStatusUI.NOTICE,
];

// The same set of live residencies, as labelled on the animal details page.
export const activeResidencyStatuses: EResidenciesStatusUI[] = [
  EResidenciesStatusUI.APPLICANT,
  EResidenciesStatusUI.FUTURE,
  EResidenciesStatusUI.RESIDENT,
  EResidenciesStatusUI.NOTICE,
];

export const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];
export const oldHud =
  'https://www.hud.gov/sites/dfiles/PA/documents/HUDAsstAnimalNC1-28-2020.pdf?fbclid=IwAR3NcG1FMmTGaw7LZ__oMwWku7wWu4R51n6AbCyHw9tgUQgi95KiMc41C4Y';

export const hudGuidelinesLink =
  'https://www.hud.gov/sites/dfiles/PA/documents/HUDAsstAnimalNC1-28-2020.pdf';

export const hasSATrainerDocumentationOptions = [
  { value: true, label: 'I have SA trainer documentation' },
  { value: false, label: 'I don’t have SA trainer documentation' },
];

export const genderOption = [
  { value: EGender.MALE, label: 'Male' },
  { value: EGender.FEMALE, label: 'Female' },
];

export const vaccinationData = [
  'Rabies',
  'Spayed/Neutered',
  'Dog liability insurance',
];

export const Category = {
  applicationSample: 'APPLICATION_SAMPLES',
  profileImage: 'PROFILE_IMAGE',
  rentalImage: 'RENTAL_IMAGE',
  applicationImage: 'APPLICATION_IMAGE',
  applicationDoc: 'APPLICATION_DOC',
  violationImage: 'VIOLATION_IMAGE',
};
